import {useEffect} from 'react';
import {connect} from 'react-redux';
import {injectIntl} from "react-intl";

const LangDomBridge = ({locale, isRTL}) => {
    useEffect(() => {
        const langAttr = (locale || 'en').split('-')[0]; // 'he-IL' -> 'he'
        // Prefer html, browsers use it for bidi + accessibility
        document.documentElement.setAttribute('lang', langAttr);
    }, [locale, isRTL]);

    return null;
};


const mapStateToProps = (state) => {
    const {lang} = state.identify;
    return {locale: lang, isRTL: lang === 'he-IL'};
};

export default connect(mapStateToProps)(injectIntl(LangDomBridge));
